<template>
  <div class="page">
    <div class="topTitle">
      <span>系统设置</span>
      / 操作日志
    </div>
    <main class="page-main">
      <el-form :model="formParams" inline size="small" label-width="80px">
        <el-form-item label="操作时间">
          <el-date-picker @change="handleSearch" v-model="formParams.date" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" placement="bottom-start"></el-date-picker>
        </el-form-item>
        <el-form-item label="操作类型">
          <el-select v-model="formParams.type" @change="handleSearch">
            <el-option v-for="item in opreationTypes" :key="item.id" :value="item.id" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人">
          <el-select v-model="formParams.userId" @change="handleSearch">
            <el-option v-for="item in opreatorList" :key="item.id" :value="item.id" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查 询</el-button>
        </el-form-item>
      </el-form>
      <br />
      <div class="table">
        <el-table ref="refTable" :data="tableData" size="mini" tooltip-effect="dark" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe height="100%">
          <el-table-column prop="" label="序号" width="50">
            <template slot-scope="scope">
              {{formParams.pageSize * (formParams.pageNum-1) + (scope.$index+1)}}
            </template>
          </el-table-column>
          <el-table-column v-for="item in tableTitle" :key="item.prop" :prop="item.prop" :label="item.label" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="formParams.pageNum" layout="total, prev, pager, next" :total="formParams.total"></el-pagination>
      </div>
    </main>
  </div>
</template>

<script>
import {
  api_userOperateSelectList,
  //   api_eduCampusSelectTchListByCampus,
} from '@/api/javaApi'

import {
  getCampusUserList
} from '@/api/educational.js'

export default {
  name: "OperationLog",
  data() {
    return {
      formParams: {
        date: null, // []
        type: null,
        userId: null,
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      opreationTypes: [
        { label: '全部', id: null },
        { label: '登录系统', id: 0 },
        { label: '删除学生', id: 1 },
        { label: '删除班级', id: 2 },
      ],
      opreationTypeEnum: {
        0: '登录系统',
        1: '删除学生',
        2: '删除班级',
      },
      opreatorList: [],
      tableTitle: [
        { prop: 'typeLabel', label: '操作类型' },
        { prop: 'createdTime', label: '操作时间' },
        { prop: 'content', label: '操作内容' },
        { prop: 'name', label: '操作人' },
        { prop: 'account', label: '操作账号' },
      ],
      tableData: [],
    }
  },
  created() {
    this.getEduCampusSelectTchListByCampus()
    this.getUserOperateSelectList();
  },
  methods: {
    // 公共查询
    handleSearch() {
      this.getUserOperateSelectList()
    },
    // 查询校区下的老师
    getEduCampusSelectTchListByCampus() {
      //   api_eduCampusSelectTchListByCampus({ eduCampusIdList: this.$store.state.user.selected_schools, }).then(res => {
      //     console.log(res)
      //   })
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then(res => {
        this.opreatorList = res.campusUserList
        this.opreatorList.forEach(item => {
          item.label = item.realname;
        })
        this.opreatorList.unshift({
          label: '全部', id: null
        })
      })
    },
    getUserOperateSelectList() {
      let startTime = null, endTime = null;
      if (this.formParams.date) {
        startTime = this.formParams.date[0]
        endTime = this.formParams.date[1]
      }
      api_userOperateSelectList({
        userId: this.formParams.userId,
        type: this.formParams.type,
        startTime,
        endTime,
        pageRequest: {
          pageNum: this.formParams.pageNum,
          pageSize: this.formParams.pageSize,
        },
      }).then(res => {
        console.log(res)
        this.tableData = res.content;
        this.tableData.forEach(item => {
          item.typeLabel = this.opreationTypeEnum[item.type];
        })
        this.formParams.total = res.totalSize;
      })
    },
    handleCurrentChange(val) {
      this.formParams.pageNum = val;
      this.handleSearch();
      this.$nextTick(() => {
        this.$refs.refTable.bodyWrapper.scrollTop = 0;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: calc(100% + 60px);
  .topTitle {
    height: 60px;
    background: #fff;
    margin: 10px;
    padding: 20px;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
    span {
      font-family: "PingFangBold";
      color: #333;
      font-size: 16px;
    }
  }
  .page-main {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin: 10px;
    padding: 20px;
    border-radius: 5px;
    background: #fff;
    .el-form {
      flex-shrink: 0;
    }
    .table {
      flex: 1;
    }
    .pagination-box {
      padding-top: 10px;
      text-align: right;
    }
  }
}
</style>